module.exports = __webpack_public_path__ + "node_modules/icheck/skins/minimal/pink.png?375a3b19";